/**
 * Created by liujianhong on 21/05/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path: any) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str: any) {
  const valid_map = ["admin", "editor"];
  return valid_map.indexOf(str.trim()) >= 0;
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
// 纳税人识别码
export function validTaxpayerCode(str: any) {
  // return /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/.test(str);
  return /^[a-zA-Z0-9]{15,20}$/.test(str);
 
}
/**
 * 银行卡号
 * @param {string} str
 * @returns {Boolean}
 */
export function validBankCard(str: any) {
  return /^([0-9]{1})(\d{8,24})$/.test(str);
}
/**
 * 手机号码
 * @param {string} str
 * @returns {Boolean}
 */
export function validPhone(str: any) {
  // return /^1[3456789]\d{9}$/.test(str);
  const reg01 = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  const reg02 = /^(0[0-9]{2,3}\-?)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
  return !(!reg01.test(str) && !reg02.test(str))
  //  validator(rule, value, callback, source, options) {
  //   let errors = [];
  //   let reg01 = /^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]||19[0-9]|14[57])[0-9]{8}$/;  
  //   let reg02 = /^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
  //   if (!reg01.test(value) && !reg02.test(value) && value !== '') {
  //       callback('请输入正确的手机号码或座机号码！');
  //   }
  //   callback(errors);}

}
/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validCard(str: any) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  return reg.test(str);
}
/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validEng(str: any) {
  const reg = /^[a-zA-Z0-9_\s]*$/;
  return !(!reg.test(str) || !str);
}
